<p-dialog
	[modal]="true"
	[(visible)]="visible"
	[dismissableMask]="true"
	[style]="{ width: '450px' }"
	(onHide)="onDialogHide()"
	[closable]="true"
>
	<!--
		DOVE-2545 QA — p-dialog resolves pTemplate="header" once in ngAfterContentInit, so three
		headers behind *ngIf meant whichever scenario rendered first kept its title for the life of
		the dialog: hitting a no-match and then a recommendation showed "Address Could Not Be
		Verified" above the recommendation. One header, chosen by expression, cannot latch.
	-->
	<ng-template pTemplate="header">
		<div class="flex align-items-center gap-2">
			<i class="text-xl" [ngClass]="dialogIconClass"></i>
			<span class="font-semibold text-lg">{{ dialogTitle }}</span>
		</div>
	</ng-template>

	<!-- Error Scenario -->
	<ng-container *ngIf="scenario === 'error'">
		<p class="text-color-secondary mb-3">Failed to validate address</p>

		<div class="surface-100 border-round p-3 mb-4">
			<p class="font-medium mb-1 text-sm">You entered:</p>
			<p class="text-color-secondary text-sm m-0">{{ formatAddress(originalAddress) }}</p>
		</div>

		<div class="flex justify-content-center gap-3">
			<p-button label="Make Changes" severity="secondary" [outlined]="true" (onClick)="onMakeChanges()" />
			<p-button label="Use Entered" (onClick)="onUseEntered()" />
		</div>
	</ng-container>

	<!-- Partial Input Scenario -->
	<ng-container *ngIf="scenario === 'found_different' && isPartialInput && standardizedAddress">
		<p class="text-color-secondary mb-3">We found the following address. Would you like to use it?</p>

		<div class="border-round border-1 border-primary surface-50 p-3 mb-4">
			<p class="font-medium mb-1 text-sm">Recommended Address</p>
			<p class="text-color-secondary text-sm m-0">{{ formatDisplayAddress(standardizedAddress) }}</p>
		</div>

		<div class="flex justify-content-end gap-3">
			<p-button label="Make Changes" severity="secondary" [outlined]="true" (onClick)="onMakeChanges()" />
			<p-button label="Use This Address" (onClick)="onUseThisAddress()" />
		</div>
	</ng-container>

	<!-- Found Different Scenario (full address) -->
	<ng-container *ngIf="scenario === 'found_different' && !isPartialInput">
		<p class="text-color-secondary mb-3">We found a recommended address. Please select which address to use.</p>

		<div class="flex flex-column gap-3 mb-4">
			<!-- Standardized Address Option -->
			<div
				class="border-round border-1 p-3 cursor-pointer"
				[ngClass]="{
					'border-primary surface-50': selectedOption === 'standardized',
					'surface-border': selectedOption !== 'standardized'
				}"
				(click)="selectedOption = 'standardized'"
			>
				<div class="flex align-items-start gap-2">
					<p-radioButton name="addressOption" value="standardized" [(ngModel)]="selectedOption" />
					<div class="flex-1">
						<p class="font-medium mb-1 text-sm">Recommended</p>
						<p class="text-color-secondary text-sm m-0">{{ formatDisplayAddress(standardizedAddress) }}</p>
					</div>
				</div>
			</div>

			<!-- Original Address Option -->
			<div
				class="border-round border-1 p-3 cursor-pointer"
				[ngClass]="{
					'border-primary surface-50': selectedOption === 'original',
					'surface-border': selectedOption !== 'original'
				}"
				(click)="selectedOption = 'original'"
			>
				<div class="flex align-items-start gap-2">
					<p-radioButton name="addressOption" value="original" [(ngModel)]="selectedOption" />
					<div class="flex-1">
						<p class="font-medium mb-1 text-sm">What you entered</p>
						<p class="text-color-secondary text-sm m-0">{{ formatAddress(originalAddress) }}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="flex justify-content-end">
			<p-button label="Confirm" (onClick)="onConfirm()" />
		</div>
	</ng-container>
</p-dialog>
